import React from "react"
import Message from ".."

//MessageBoard is an array containing Message objects {name, text}
//has a prop "subject" and "messages"
const MessageBoard = props => {
return <div></div>
}

export default MessageBoard
